import React from 'react';
import './informacion-util.scss'
import { sanitizeRichHtml } from "../../utils/sanitize";
import { fetch } from "../../utils/fetch";
import DynamicCommonLoader from '../../components/common-loader/dynamicCommonLoader';
import Card from 'react-bootstrap/Card';

const getItemColClass = (itemsCount) => {
  const colSize = Math.floor(12 / Math.max(itemsCount, 1));
  return `col-lg-${colSize}`;
};

const InformacionUtilPage = () => {


  const [loader, setLoader] = React.useState(true)
  const [contenido, setContenido] = React.useState(null);

  React.useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const { data } = await fetch(`informacion-util-dinamicas?_eliminado=false&_sort=orden:ASC`, "GET");
      setContenido(data[0]);
      setLoader(false)
    } catch (error) {
      setLoader(false)
    }
  };

  const bloques = contenido?.bloques_informacion_util || [];

return(
  <>
    {loader 
      ? 
      
        <DynamicCommonLoader dynamic={"225px"}/>
      
      : 
      
        <>
        {contenido && 
        <>
        <section className='desktop'>
        <div className="container" >
          <div className="row mt-5">
            <div className="col-lg-12">            
              <h3 className="global_subtitle bold">{contenido.nombre}</h3>
              <hr className="hr6" />
              <p>{contenido.descripcion}</p>
            </div>
          </div>
          {bloques.map((bloque) => {
            const items = bloque.items || [];
            const colClass = getItemColClass(items.length);

            return (
              <div className="col-lg-12 fondo" key={bloque.id}>
                <div className="row">
                  <div className="col-lg-3">
                    {bloque.imagen?.url && (
                      <img
                        className="borde img-informacion"
                        src={bloque.imagen.url}
                        alt={bloque.imagen.alternativeText || bloque.titulo || ''}
                        width="250px"
                      />
                    )}
                  </div>
                  <div className="col-lg-9">
                    <div className="row h-100 d-flex align-items-center">
                      {items.map((item, index) => (
                        <div
                          key={item.id}
                          className={`${colClass} h-100 d-flex align-items-center justify-content-center`}
                          style={index < items.length - 1 ? { borderRight: '4px solid #CEDCE9' } : undefined}
                        >
                          <div
                            className="innerHTML"
                            dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(item.descripcion) }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          </div>
        </section>
        

      <section className='mobile'>
      <div className="container" >
          <div className="row mt-5">
            <div className="col-lg-12">            
              <h2 className="global_subtitle bold">{contenido.nombre}</h2>
              <div className="hr6" />

              <p>{contenido?.descripcion}</p>
            </div>
          </div>
          </div>
          <div className='card-wrapper'>
            {bloques.flatMap((bloque) =>
              (bloque.items || []).map((item) => (
                <Card style={{ width: '18rem' }} key={item.id}>
                  <Card.Body>
                    <Card.Text>
                      <div
                        className="innerHTML"
                        style={{ textAlign: "center" }}
                        dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(item.descripcion) }}
                      />
                    </Card.Text>
                  </Card.Body>
                </Card>
              ))
            )}
        </div>
      </section>
      
      </>
        }
        </>

    
    }
  </>
    

);
}
export default InformacionUtilPage;